import { render, staticRenderFns } from "./MainCarousel.vue?vue&type=template&id=2bff98b6&"
import script from "./MainCarousel.vue?vue&type=script&lang=js&"
export * from "./MainCarousel.vue?vue&type=script&lang=js&"
import style0 from "./MainCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports